import { IUpdateWidgetConfigData } from '../_models/widgetInterface'
import { get, put } from './apiServices'

const getWidgetConfig = async () => {
  const response = await get('/business/widget')
  return response
}

const updateWidgetConfig = async (params: IUpdateWidgetConfigData) => {
  const response = await put('/business/widget', params)
  return response
}

const widgetService = {
  getWidgetConfig,
  updateWidgetConfig,
}

export default widgetService
